// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notif {\n  position: relative;\n  cursor: pointer;\n}\n.notif .unread {\n  position: absolute;\n  left: 10px;\n  top: -4px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  background: #ff4446;\n  border: 1px solid #ffffff;\n  border-radius: 46px;\n  padding: 0 4px;\n  color: #ffffff;\n  font-size: 12px;\n  line-height: 1;\n  min-width: 24px;\n  height: 16px;\n}", ""]);
// Exports
module.exports = exports;
